var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-card",
    { staticClass: "col", class: _vm.tone, attrs: { shadow: "never" } },
    [
      _c(
        "div",
        {
          staticClass: "col-header",
          attrs: { slot: "header" },
          slot: "header",
        },
        [
          _c("span", { staticClass: "col-title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm.side
            ? _c("span", { staticClass: "col-ms" }, [
                _vm._v(_vm._s(_vm.side.ms) + " ms"),
              ])
            : _vm._e(),
        ]
      ),
      !_vm.side
        ? _c("div", { staticClass: "empty" }, [
            _vm._v(_vm._s(_vm.$t("placesCompare.noRun"))),
          ])
        : [
            _vm.side.error
              ? _c("el-alert", {
                  staticClass: "err",
                  attrs: {
                    type: "error",
                    closable: false,
                    title: _vm.side.error,
                  },
                })
              : _vm._e(),
            _c("div", { staticClass: "stats" }, [
              _c("div", { staticClass: "stat" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.side.count)),
                ]),
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("placesCompare.count"))),
                ]),
              ]),
              _c("div", { staticClass: "stat" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.side.nearest === null ? "-" : _vm.side.nearest + " m"
                    )
                  ),
                ]),
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("placesCompare.nearest"))),
                ]),
              ]),
              _c("div", { staticClass: "stat" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.side.farthest === null
                        ? "-"
                        : _vm.side.farthest + " m"
                    )
                  ),
                ]),
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("placesCompare.farthest"))),
                ]),
              ]),
              _c("div", { staticClass: "stat" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.side.onlyHere)),
                ]),
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("placesCompare.onlyHere"))),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "fields" },
              [
                _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("placesCompare.withPhone")) +
                      ": " +
                      _vm._s(_vm.side.withPhone) +
                      "/" +
                      _vm._s(_vm.side.count)
                  ),
                ]),
                _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("placesCompare.withWebsite")) +
                      ": " +
                      _vm._s(_vm.side.withWebsite) +
                      "/" +
                      _vm._s(_vm.side.count)
                  ),
                ]),
                _c("el-tag", { attrs: { size: "mini", type: "info" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("placesCompare.withRating")) +
                      ": " +
                      _vm._s(_vm.side.withRating) +
                      "/" +
                      _vm._s(_vm.side.count)
                  ),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "list" },
              [
                _vm._l(_vm.side.pois, function (p, i) {
                  return _c(
                    "div",
                    {
                      key: p.id || i,
                      staticClass: "item",
                      class: { unique: _vm.isUnique(p.name) },
                    },
                    [
                      _c("div", { staticClass: "item-head" }, [
                        _c("span", { staticClass: "idx" }, [
                          _vm._v(_vm._s(i + 1)),
                        ]),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(p.name)),
                        ]),
                        _c("span", { staticClass: "dist" }, [
                          _vm._v(_vm._s(Math.round(p.distance)) + " m"),
                        ]),
                      ]),
                      _c("div", { staticClass: "item-sub" }, [
                        p.categoryName
                          ? _c("span", { staticClass: "cat" }, [
                              _vm._v(_vm._s(p.categoryName)),
                            ])
                          : _vm._e(),
                        _c("span", { staticClass: "addr" }, [
                          _vm._v(_vm._s(p.address)),
                        ]),
                      ]),
                      _c("div", { staticClass: "item-meta" }, [
                        _c("span", { class: p.phone ? "has" : "hasnt" }, [
                          _vm._v(_vm._s(_vm.$t("placesCompare.phone"))),
                        ]),
                        _c("span", { class: p.websiteUri ? "has" : "hasnt" }, [
                          _vm._v(_vm._s(_vm.$t("placesCompare.website"))),
                        ]),
                        _c(
                          "span",
                          { class: p.rating ? "has" : "hasnt" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("placesCompare.rating"))
                            ),
                            p.rating
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(p.rating) +
                                      " (" +
                                      _vm._s(p.userRatingCount) +
                                      ")"
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ]
                  )
                }),
                !_vm.side.pois.length && !_vm.side.error
                  ? _c("div", { staticClass: "empty" }, [
                      _vm._v(_vm._s(_vm.$t("placesCompare.noResult"))),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }